<div class="percent-display-container" fxLayout>
  <span
    class="label-text"
    fxFlex="18%"
    matTooltip="{{ label }}"
    matTooltipPosition="after"
    matTooltipShowDelay="500"
    [matTooltipDisabled]="disableTooltip"
  >
    {{ label }}
  </span>
  <div class="percent-bar-container" fxFlex fxLayout (click)="doClick()">
    <div [ngClass]="isOnTeams ? 'percent-bar-on-teams' : 'percent-bar'" [ngStyle]="{ width: percentage + '%' }"></div>
    <div
      [ngClass]="isOnTeams ? 'percent-bar-on-teams-opaque' : 'percent-bar-opaque'"
      [ngStyle]="{ width: 100 - percentage + '%' }"
    ></div>
    <span class="percent-text" fxFlex="none">{{ percentage | number: '1.0-1' }}%</span>
  </div>
  <span fxFlex="10%" fxLayout="row">
    <span class="count-text" fxFlex="50%">{{ count }}</span>
  </span>
</div>
